import qs from 'query-string';

import appConfig from '../../appConfig';


function merchantApiFactory(storefrontApiClient) {
  return {
    getMerchantInfo({postfix, ...rest}) {
      return storefrontApiClient.get(`getMerchantInfo/${postfix}`, {
        ...rest,
      });
    },

    getMerchantInfoByName({postfix, ...rest}) {
      return storefrontApiClient.get(`${appConfig.merchantQueryServiceApiUrl}/merchants/${postfix}`, {
        ...rest
      })
    },
    getSuperTabData({merchantId, ...rest}) {
      return storefrontApiClient.get(`${appConfig.merchantContentServiceApiUrl}/merchanthassupertab/${merchantId}`, {
        ...rest
      })
    },
    getMerchantInfoByPostfix({postfix, ...rest}) {
      return storefrontApiClient.get(`${appConfig.merchantContentServiceApiUrl}/merchants?urlpostfix=${postfix}`, {
        ...rest
      })
    },

    getMerchantSearch(params) {
      return storefrontApiClient.get(`merchantSearch?${qs.stringify(params)}`);
    },

  };
}

export default merchantApiFactory;
